var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"d-flex align-items-center flex-fill"},[(_vm.isShowTotal)?_c('h6',{staticClass:"m-0 typo-body-2"},[_vm._v(" "+_vm._s(_vm.totalSelect)+" Selected ")]):_vm._e(),(_vm.isShowClear)?_c('div',{class:[
				'color-black-45',
				{
					'ml-3 pl-2 clear-action': _vm.isShowTotal
				}
			]},[_c('button',{class:[
					'clear-button typo-body-2 border-0 bg-transparent color-black-45',
					{
						'p-0': !_vm.isShowTotal
					}
				],attrs:{"disabled":_vm.disabledClear},on:{"click":_vm.handleClear}},[_vm._v(" Clear all selected ")])]):_vm._e()]),_c('CButton',{staticClass:"modal-button transparent mr-3",attrs:{"disabled":_vm.disabledCancel,"color":"tertiary"},on:{"click":_vm.handleCancel}},[_vm._v(" Cancel ")]),_c('CButton',{staticClass:"modal-button transparent",attrs:{"disabled":_vm.disabledComfirm,"color":"primary"},on:{"click":_vm.handleConfirm}},[_vm._v(" Done ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }